import { AumChart, aumDistributionChart } from '../redux-store/types/api-types';

export function filteringAum(array: Array<AumChart>) {
    // console.log('array', array)

    const filterArray = [...array].sort((a, b) => Number(b.netAssets) - Number(a.netAssets)).filter((item: AumChart) => Number(item.netAssets) > 0)
    console.log('filterArray', filterArray)

    const familyName: Array<string> = [];
    const familyId: Array<string> = [];
    const individual: Array<string> = [];

    [...filterArray]?.reduce((prev = [], curr: AumChart): any => {
        if (!individual.includes(curr.customer)) {
            individual.push(curr.customer);
        }

        if (curr.familyId && !familyId.includes(curr.familyId)) {
            familyId.push(curr.familyId);
        }
        return prev;
    }, []);


    // aum chart Family
    const AumFamilyName: Array<string> = [];
    const AumFamilyValue: Array<number> = [];
    const AumFamilyIds: Array<string> = [];
familyId.filter((id) => id && id !== "Not Applicable").forEach((id) => {
        const total = filterArray.reduce((prev: number, curr: AumChart) => {
            return curr.familyId === id
                ? prev + (Number(curr?.netAssets) ?? 0)
                : prev;
        }, 0);
        const label = filterArray.find((row) => row.familyId === id)?.familyName ?? "";
        AumFamilyName.push(label);
        AumFamilyValue.push(total);
        AumFamilyIds.push(id);
    });

    // aum chart individual
    const AumIndividualName: Array<string> = [];
    const AumIndividualValue: Array<number> = [];

    // individual.map((item, i) => {
    //     const findIndex = filterArray.findIndex((obj: AumChart) => obj.customer === item);
    //     console.log('findIndex', findIndex)

    //     AumIndividualName.push(filterArray[findIndex]?.customerName);
    //     AumIndividualValue.push(Number(filterArray[findIndex]?.netAssets));
    //     return item
    // })

    // console.log('individual', individual)

    individual.filter((item) => item !== "Not Applicable").forEach((item: string, index) => {
        const individualAssetValue = filterArray.reduce((prev: any, curr: AumChart): any => {
            if (curr.customer === item) {
                return prev + (Number(curr?.netAssets) ?? 0);
            } else {
                return prev;
            }
        }, 0);

        const individualAssetName = filterArray.reduce((prev: any, curr: AumChart): any => {
            if (curr.customer === item) {
                return curr.customerName;
            } else {
                return prev;
            }
        }, 0);

        AumIndividualName.push(individualAssetName);
        AumIndividualValue.push(individualAssetValue);
    });



    return {
        aum: {
            family: {
                name: AumFamilyName.length > 5 ? [...AumFamilyName.slice(0, 5)] : AumFamilyName,
                value: AumFamilyValue.length > 5 ? [...AumFamilyValue.slice(0, 5)] : [...AumFamilyValue],
                ids: AumFamilyIds.length > 5 ? [...AumFamilyIds.slice(0, 5)] : [...AumFamilyIds],
            },
            individual: {
                name: AumIndividualName.length > 5 ? [...AumIndividualName.slice(0, 5), "Others"] : AumIndividualName,
                value: AumIndividualValue.length > 5 ? [...AumIndividualValue.slice(0, 5)] : [...AumIndividualValue],
                ids: [] as Array<string>,
            },
        },
        filterOption: [
            {
                label: 'By Individual',
                value: 1,
            },
            {
                label: 'By Family',
                value: 2,
            },
        ],
    };
}
